import { PecSwitch } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'
import { match, Redirect, Route } from 'react-router'
import { CidadaoMedicoes } from 'view/atendimentos/detail/soap/aside/medicoes/model'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { PeriodoGestacaoModel } from '../types/PeriodoGestacaoModel'
import { HistoricoMedicoesExameFisicoView } from './exame-fisico/HistoricoMedicoesExameFisicoView'
import { MODAL_MEDICAO_ANTERIOR_EXAME_FISICO_TAB_URL } from './exame-fisico/model-medicaoAnteriorExameFisico'
import { isMedicaoAnteriorExameFisico } from './exame-fisico/utils-medicaoAnteriorExameFisico'
import { HistoricoMedicoesAntropometriaView } from './HistoricoMedicoesAntropometriaView'
import { HistoricoMedicoesGlicemiaView } from './HistoricoMedicoesGlicemiaView'
import { HistoricoMedicoesSinaisVitaisView } from './HistoricoMedicoesSinaisVitaisView'
import { HistoricoMedicoesPreNatalView } from './pre-natal/HistoricoMedicoesPreNatalView'
import { getMedicoesAntropometricasPreNatal } from './pre-natal/util-medicoesPreNatal'

export interface ReadOnlyHistoricoMedicoesModalBodyProps {
  initialRoute: string
  match: match
  cidadao: CidadaoMedicoes
  prontuarioId: ID
  medicoes: ReadonlyArray<HistoricoMedicaoModel>
  gestacoes: ReadonlyArray<PeriodoGestacaoModel>
  isAtendimentoObservacao: boolean
  isGestante: boolean
  dataAtendimento: number
}

export function ReadOnlyHistoricoMedicoesModalBody({
  initialRoute,
  match,
  cidadao,
  prontuarioId,
  medicoes = [],
  isAtendimentoObservacao,
  gestacoes,
  isGestante,
  dataAtendimento,
}: Readonly<ReadOnlyHistoricoMedicoesModalBodyProps>) {
  const { PAC_EQUIPAMENTO_ENABLED } = useFlags()

  const medicoesAnterioesExameFisico = medicoes.filter((medicao) => isMedicaoAnteriorExameFisico(medicao))

  return (
    <PecSwitch>
      <Redirect exact path={match.url} to={`${match.url}${initialRoute}`} />
      <Route
        path={`${match.url}/pre-natal`}
        render={(renderProps) => (
          <HistoricoMedicoesPreNatalView
            {...renderProps}
            prontuarioId={prontuarioId}
            medicoesAntropometricasPreNatal={getMedicoesAntropometricasPreNatal([...medicoes])}
            dataAtendimento={dataAtendimento}
          />
        )}
      />
      <Route
        path={`${match.url}/antropometria`}
        render={(renderProps) => (
          <HistoricoMedicoesAntropometriaView
            {...renderProps}
            medicoes={medicoes}
            cidadao={cidadao}
            gestacoes={gestacoes}
            canEditOrAdd={false}
            isAtendimentoObservacao={isAtendimentoObservacao}
            isGestante={isGestante}
          />
        )}
      />
      <Route
        path={`${match.url}/sinaisVitais`}
        render={(renderProps) => (
          <HistoricoMedicoesSinaisVitaisView {...renderProps} medicoes={medicoes} gestacoes={gestacoes} />
        )}
      />
      <Route
        path={`${match.url}/glicemia`}
        render={(renderProps) => (
          <HistoricoMedicoesGlicemiaView {...renderProps} medicoes={medicoes} gestacoes={gestacoes} />
        )}
      />
      {PAC_EQUIPAMENTO_ENABLED && (
        <Route
          path={`${match.url}${MODAL_MEDICAO_ANTERIOR_EXAME_FISICO_TAB_URL}`}
          render={(renderProps) => (
            <HistoricoMedicoesExameFisicoView
              {...renderProps}
              dataAtendimento={dataAtendimento}
              dataNascimentoCidadao={cidadao.dataNascimento}
              medicoes={medicoesAnterioesExameFisico}
              canEditOrAdd={false}
              isAtendimentoObservacao={isAtendimentoObservacao}
            />
          )}
        />
      )}
    </PecSwitch>
  )
}
